import { AdditionalInformationParsed } from './../apps/shoppingCart/interfaces/configuration';
import { NzTableComponent } from 'ng-zorro-antd/table';
import { LayoutService } from './layout.service';
import * as g from 'src/app/globals';
import { Router, ActivatedRoute } from '@angular/router';
import {
  Field,
  FieldDataType,
  ModuleStructure,
  Section,
} from './../models/module-structure';
import { Guid } from './../models/guid';
import * as moment from 'moment';
import { RecordPageComponent } from './record-page/record-page.component';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import {
  ChangedValueModelActionType,
  CustomActionResponse,
  CustomActionResult,
  ResultType,
} from '../models/CustomActionResult';
import { RecordListDrawerArgs } from '@app/models/record-list-drawer-args';
import { RecordsListComponent } from './records-list/records-list.component';

export class RecordProperties {
  ValidateValueForLinkedValue?: boolean;
  IgnoreAutoPrice?: boolean;
  FromAutoPrice?: boolean;
  constructor() {}

  // FieldDataType: number;
  FieldId?: number;
  FieldName?: string;
  Name?: string;
  Value?: string;
  CssClass?: string;
  ValueAsObject?: any;
  ValueAsObjectArr?: any[];
  DBValue?: string;
  Disabled?: boolean;
  ForceKeepValue?: boolean;
  DataType?: FieldDataType;
  DialogVisible?: boolean;
  ExecuteParentChangeOnLoad?: boolean;
  DialogVisibleDrawerInitialized?: boolean;
  IsNew?: boolean;
  ReadOnly?: boolean;
  PrevReadOnlyValue?: boolean;
  PrevRequiredValue?: boolean;
  Initialized?: boolean;
  MaxValue?: number;
  MinValue?: number;
  MaxValueToolTip?: number;
  MinValueToolTip?: number;
  Visible?: boolean;
  Required?: boolean;
  Label?: string;
  EditMode?: boolean;
  InTable?: boolean;
  EmptyValue?: string;
  Options?: any;
  // tslint:disable-next-line: whitespace
  LoadingOptionsIndex? = 0;
  // tslint:disable-next-line: whitespace
  ChangedValueIndex? = 0;
  IsImage?: boolean;
}

export class RecordLine {
  Id: number;
  // tslint:disable-next-line: whitespace
  Title? = '';
  // tslint:disable-next-line: whitespace
  IsEditMode? = false;
  // tslint:disable-next-line: whitespace
  IsEditModeDrawerInitialized? = false;
  Properties: RecordProperties[];
  MaxIndex?: number;
  Visible?: boolean;
  LineTemplateHtml?: string;
  QuantityProp?: RecordProperties;
  OpenQtyProp?: RecordProperties;
  BaseItemCodeProp?: RecordProperties;
  TreeTypeProp?: RecordProperties;
  ItemCodeProp?: RecordProperties;
  // tslint:disable-next-line: whitespace
  IsNew? = false;
  static addNewLine(
    recordModel: RecordModel,
    section: Section,
    maxLineNum: number,
    defaultVals,
    moduleStructure: ModuleStructure,
    layoutService: LayoutService,
    afterIndex: number = -1,
  ): RecordLine {
    maxLineNum--;
    let lines: RecordLine[];
    let recordCategory: RecordCategory = recordModel.Categories.find(
      (x) => x.Id == section.XmlTagName,
    );
    // recordModel.Categories.forEach((category) => {
    //   if (category.Id === section.XmlTagName) {
    //     recordCategory = category;
    //     return;
    //   }
    // });

    if (recordCategory == null) {
      recordCategory = {
        Id: section.XmlTagName,
        Lines: [],
        DeletedLines: [],
      };
      recordModel.Categories.push(recordCategory);
    }

    if (maxLineNum === undefined || isNaN(maxLineNum)) {
      const lastLine = recordCategory.Lines[
        recordCategory.Lines.length - 1
      ].Properties.find((x) => x.Name === 'LineNum');
      if (lastLine != null) {
        maxLineNum = lastLine.ValueAsObject;
      }

      //maxLineNum = recordCategory.Lines.length;
    }

    if (recordCategory.Lines.length !== 0 && maxLineNum === 0) {
      if (
        recordModel.ObjectKey === 'InventoryCounting' ||
        recordModel.ObjectKey === 'InventoryPosting' ||
        recordModel.ObjectKey === 'oProductionOrders'
      ) {
        if (
          recordCategory.MaxIndex === 0 ||
          recordCategory.MaxIndex === undefined
        ) {
          maxLineNum =
            Math.max.apply(
              Math,
              recordCategory.Lines.map((o) => {
                if (
                  o.Properties.find((prop) => prop.Name === 'LineNumber') ===
                  undefined
                ) {
                  return recordCategory.Lines.length;
                } else {
                  return o.Properties.find((prop) => prop.Name === 'LineNumber')
                    .ValueAsObject;
                }
              }),
            ) + 1;
        } else {
          if (recordCategory.MaxIndex === undefined) {
            recordCategory.MaxIndex = 1;
          }
          recordCategory.MaxIndex++;
          maxLineNum = recordCategory.MaxIndex;
        }
      } else if (recordModel.ObjectKey === 'BlanketAgreement') {
        if (
          recordCategory.MaxIndex === 0 ||
          recordCategory.MaxIndex === undefined
        ) {
          maxLineNum =
            Math.max.apply(
              Math,
              recordCategory.Lines.map((o) => {
                if (
                  o.Properties.find(
                    (prop) => prop.Name === 'AgreementRowNumber',
                  ) === undefined
                ) {
                  return recordCategory.Lines.length;
                } else {
                  return o.Properties.find(
                    (prop) => prop.Name === 'AgreementRowNumber',
                  ).ValueAsObject;
                }
              }),
            ) + 1;
        } else {
          if (recordCategory.MaxIndex === undefined) {
            recordCategory.MaxIndex = 1;
          }
          recordCategory.MaxIndex++;
          maxLineNum = recordCategory.MaxIndex;
        }
      } else {
        if (
          recordCategory.MaxIndex === 0 ||
          recordCategory.MaxIndex === undefined
        ) {
          maxLineNum =
            Math.max.apply(
              Math,
              recordCategory.Lines.map((o) => {
                if (
                  o.Properties.find((prop) => prop.Name === 'LineNum') ===
                  undefined
                ) {
                  return recordCategory.Lines.length;
                } else {
                  return o.Properties.find((prop) => prop.Name === 'LineNum')
                    .ValueAsObject;
                }
              }),
            ) + 1;
        } else {
          if (recordCategory.MaxIndex === undefined) {
            recordCategory.MaxIndex = 1;
          }
          recordCategory.MaxIndex++;
          maxLineNum = recordCategory.MaxIndex;
        }
      }
    } else {
      if (
        recordCategory.MaxIndex === undefined ||
        recordCategory.MaxIndex === 0
      ) {
        recordCategory.MaxIndex = maxLineNum;
      }
      recordCategory.MaxIndex++;
      maxLineNum = recordCategory.MaxIndex;
    }
    //  else {
    //   maxLineNum++;
    // }

    if (
      recordCategory.LineToDelete != null &&
      recordCategory.LineToDelete !== undefined &&
      recordCategory.LineToDelete !== '' &&
      recordModel.EventType == EventType.Update
    ) {
      console.log(recordCategory.LineToDelete);
      const numbers = recordCategory.LineToDelete.toString()
        .split(',')
        .map(Number);
      const maxNumber = Math.max(...numbers);
      if (maxLineNum < maxNumber) {
        maxLineNum = maxNumber + 1;
      }
    }

    let recordLine: RecordLine = null;
    recordLine = {
      Id: maxLineNum,
      MaxIndex: maxLineNum,
      Properties: [],
    };

    recordCategory.MaxIndex = maxLineNum;
    // maxLineNum = maxLineNum + 1;
    RecordModel.refineTheRecordModelLine(
      layoutService,
      section,
      recordLine,
      defaultVals,
    );

    layoutService.lineAdded.emit({
      recordLine,
      moduleStructure: moduleStructure,
      section: section,
      recordModel: recordModel,
    });

    recordCategory.Lines.splice(
      afterIndex === -1 ? maxLineNum : afterIndex,
      0,
      recordLine,
    );

    recordLine.IsNew = true;
    recordCategory.Lines = [...recordCategory.Lines];
    lines = recordCategory.Lines;
    console.log('lines', lines);

    for (const property of recordLine.Properties) {
      const field = section.Fields.find(
        (p) => p.PropertyName === property.Name,
      );
      if (field.ParentProperties != null && field.ParentProperties !== '') {
        let queryIdToExecute = field.SQLStatementParentChanged;
        if (queryIdToExecute == null || queryIdToExecute === 0) {
          queryIdToExecute = field.SQLStatementId;
        }

        if (queryIdToExecute != null && queryIdToExecute !== 0) {
          layoutService.getFieldValueOnParentChange(
            recordModel,
            recordCategory,
            recordLine,
            property,
            queryIdToExecute,
            field,
            moduleStructure,
            true,
          );
        }
      }
    }
    return recordLine;
  }
}

export class SpecialLines {
  LineSeq: number;
  // tslint:disable-next-line: whitespace
  Title? = '';
  AftLineNum?: number;
  LineText?: string;
  //LineGUID?: string;
  LineType: string;
  IsNew?: boolean;
  Id: number;
}

export class SLineProperties {
  constructor() {}

  // FieldDataType: number;
  FieldName?: string;
  Name?: string;
  Value?: string;
  ValueAsObject?: any;
  DBValue?: string;
  Disabled?: boolean;
  DataType?: FieldDataType;
  Visible: boolean;
  // DocEntry: string;
  // LineSeq?: number;
  // AftLineNum: number;
  // OrderNum?: string;
  // LineType?: string;
  // LineText: string;
  // LogInstanc?: string;
  // ObjType?: string;
  // Visible = true;
}

export class RecordCategory {
  Id: string;
  Lines?: RecordLine[];
  TempLines?: RecordLine[];
  DeletedLines?: RecordLine[];
  SpecialLines?: SpecialLines[];
  LineToDelete?: string;
  PropertyNameInParent?: string;
  KeyPropertyName?: string;
  KeyFieldName?: string;
  AdditionalIdentifier?: string;
  Dataset?: any[];
  MaxIndex?: number;
}

export enum EventType {
  Create = 0,
  Update = 1,
  Remove = 2,
  View = 3,
}

export enum ModuleType {
  Unkown = 0,
  BusinessService = 1,
  BusinessObject = 2,
  UserDefinedTable = 3,
  UserDefinedObject = 4,
  CustomAction = 5,
}

export class SourceDocument {
  TableName: string;
  Name: string;
  Id: string;
  IsReserved: boolean;
}
export class ApprovalTemplate {
  ForceChange: boolean;
  Name: string;
  Remark: string;
  TemplateID: number;
  UserInput: string;

  constructor() {
    this.ForceChange = false;
    this.Name = '';
    this.Remark = '';
    this.TemplateID = 0;
    this.UserInput = '';
  }
}

export class RecordModel {
  static getShippingDetailsLastRequestId: string;
  constructor() {
    this.RemoveMethodName = 'Remove';
    this.CreateMethodName = 'Create';
    this.UpdateMethodName = 'Update';

    this.LinesToDelete = '';
    this.TableName = '';
    this.KeyValue = '';
    this.KeyName = '';
    this.ObjectKey = '';
    this.ModuleApp = '';
    this.AllowSaveToDraft = false;
    this.ObjectCode = '';
    this.FormGUID = Guid.newGuid();
    this.ObjectTypeValue = '';
    //for blanketAgreement
    this.copiedQuotEntries = [];
    //end

    this.EventType = EventType.Create;
    this.ModuleType = ModuleType.BusinessObject;

    this.IsPublic = false;
    this.FromDraft = false;
    this.ModuleId = 0;
    this.UnkownKeys = [];
    this.Categories = [];
    this.LastBatchNumber = '';
  }
  RemoveMethodName = 'Remove';
  CreateMethodName = 'Create';
  UpdateMethodName = 'Update';

  LinesToDelete = '';
  TableName = '';
  KeyValue = '';
  SourceObjectId? = '';
  KeyName = '';
  ObjectKey = '';
  ModuleApp = '';
  ObjectCode = '';
  FormGUID = '';
  ObjectTypeValue = '';
  //for blanketAgreement
  copiedQuotEntries: string[] = [];
  //end
  AllowSaveToDraft = false;
  IsPublic? = false;
  LastBatchNumber? = '';

  EventType?: EventType = EventType.Create;
  ModuleType?: ModuleType = ModuleType.BusinessObject;

  ThereIsChange? = false;
  FromDraft = false;
  ModuleId = 0;
  UnkownKeys?: RecordProperties[] = [];
  Categories: RecordCategory[] = [];
  TableSections?: any;
  static ExecuteCustomAction(
    customActionCode: string,
    layoutService: LayoutService,
    recordModel: RecordModel,
    sectionLine: string,
    moduleStructure: ModuleStructure,
    drawerService: NzDrawerService,
    parentComponent: any,
    dataToProcess: string,
    router: Router,
    callback: () => void,
  ) {
    const copyRecordModel = JSON.parse(
      JSON.stringify(recordModel),
    ) as RecordModel;

    for (const category of copyRecordModel.Categories) {
      if (category.hasOwnProperty('TempLines')) {
        delete category['TempLines'];
      }
      if (category.hasOwnProperty('DeletedLines')) {
        delete category['DeletedLines'];
      }
      if (category.hasOwnProperty('SpecialLines')) {
        delete category['SpecialLines'];
      }
      if (category.hasOwnProperty('LineToDelete')) {
        delete category['LineToDelete'];
      }
      if (category.hasOwnProperty('KeyFieldName')) {
        delete category['KeyFieldName'];
      }
      if (category.hasOwnProperty('KeyPropertyName')) {
        delete category['KeyPropertyName'];
      }
      if (category.hasOwnProperty('PropertyNameInParent')) {
        delete category['PropertyNameInParent'];
      }
      if (category.hasOwnProperty('AdditionalIdentifier')) {
        delete category['AdditionalIdentifier'];
      }
      if (category.hasOwnProperty('AlwaysHasDefaultValue')) {
        delete category['AlwaysHasDefaultValue'];
      }
      if (category.hasOwnProperty('Disabled')) {
        delete category['Disabled'];
      }
      if (category.hasOwnProperty('MaxIndex')) {
        delete category['MaxIndex'];
      }
      if (category.hasOwnProperty('DataSet')) {
        delete category['DataSet'];
      }
      for (const line of category.Lines) {
        if (line !== undefined) {
          if (line.hasOwnProperty('QuantityProp')) {
            delete line['QuantityProp'];
          }
          if (line.hasOwnProperty('OpenQtyProp')) {
            delete line['OpenQtyProp'];
          }
          if (line.hasOwnProperty('BaseItemCodeProp')) {
            delete line['BaseItemCodeProp'];
          }
          if (line.hasOwnProperty('TreeTypeProp')) {
            delete line['TreeTypeProp'];
          }
          if (line.hasOwnProperty('ItemCodeProp')) {
            delete line['ItemCodeProp'];
          }
          if (line.hasOwnProperty('LineTemplateHtml')) {
            delete line['LineTemplateHtml'];
          }
          if (line.hasOwnProperty('CssClass')) {
            delete line['CssClass'];
          }
          if (line.hasOwnProperty('Visible')) {
            delete line['Visible'];
          }
          for (const prop of line.Properties) {
            if (prop.hasOwnProperty('ExecuteParentChangeOnLoad')) {
              delete prop.ExecuteParentChangeOnLoad;
            }
            if (prop.hasOwnProperty('AdditionalInformation')) {
              delete prop['AdditionalInformation'];
            }
            if (prop.hasOwnProperty('AdditionalInformationModel')) {
              delete prop['AdditionalInformationModel'];
            }
            if (prop.hasOwnProperty('IsHTML')) {
              delete prop['IsHTML'];
            }
            if (prop.hasOwnProperty('ReadOnly')) {
              delete prop['ReadOnly'];
            }
            if (prop.hasOwnProperty('IsImage')) {
              delete prop['IsImage'];
            }
            if (prop.hasOwnProperty('EscapedValue')) {
              delete prop['EscapedValue'];
            }
            if (prop.hasOwnProperty('Escape')) {
              delete prop['Escape'];
            }
            if (prop.hasOwnProperty('Options')) {
              delete prop['Options'];
            }
            if (prop.hasOwnProperty('Initialized')) {
              delete prop['Initialized'];
            }
            if (prop.hasOwnProperty('InTable')) {
              delete prop['InTable'];
            }
            if (prop.hasOwnProperty('Visible')) {
              delete prop['Visible'];
            }
            if (prop.hasOwnProperty('Required')) {
              delete prop['Required'];
            }
            if (prop.hasOwnProperty('Label')) {
              delete prop['Label'];
            }
            if (prop.hasOwnProperty('ValueChanged')) {
              delete prop['ValueChanged'];
            }
            if (prop.hasOwnProperty('EmptyValue')) {
              delete prop['EmptyValue'];
            }
            if (prop.hasOwnProperty('LoadingOptionsIndex')) {
              delete prop['LoadingOptionsIndex'];
            }
            if (prop.hasOwnProperty('DBValue')) {
              delete prop['DBValue'];
            }
            if (prop.hasOwnProperty('DataType')) {
              delete prop['DataType'];
            }
            if (prop.hasOwnProperty('Disabled')) {
              delete prop['Disabled'];
            }
          }
        }
      }
    }
    layoutService
      .pushDataToBackend(
        JSON.stringify(copyRecordModel),
        customActionCode + (sectionLine === '' ? '' : '_' + sectionLine),
        dataToProcess,
      )
      .subscribe((e: any) => {
        callback();
        let actionResult: CustomActionResponse;
        try {
          actionResult = JSON.parse(e.Resault_Value) as CustomActionResponse;
        } catch (error) {
          return;
        }
        if (actionResult.ResultType === ResultType.ChangedValues) {
          const result = actionResult.Result as CustomActionResult[];
          for (const changedProperty of result) {
            const category = recordModel.Categories.find(
              (c) => c.Id === changedProperty.CategoryId,
            );

            const line = category.Lines.find(
              (l) => l.Id === changedProperty.LineId,
            );
            if (
              changedProperty.ActionType ===
              ChangedValueModelActionType.SetValue
            ) {
              const property = line.Properties.find(
                (p) => p.Name === changedProperty.PropertyName,
              );

              LayoutService.setValue(
                property,
                changedProperty.Value,
                layoutService,
                recordModel,
                changedProperty.LineId,
                changedProperty.CategoryId,
                moduleStructure,
              );

              if (changedProperty.ShowSuccessMsg) {
                parentComponent.message.success(
                  layoutService.translate(
                    'Your operation has been completed successfully!',
                  ),
                );

                parentComponent.reloadModel();
              }
            } else if (
              changedProperty.ActionType === ChangedValueModelActionType.AddLine
            ) {
              const lineSection = moduleStructure.module.Sections.find(
                (x) => x.XmlTagName === changedProperty.CategoryId,
              );

              if (customActionCode.startsWith('GetShippingDetails')) {
                if (
                  customActionCode.indexOf(
                    RecordModel.getShippingDetailsLastRequestId,
                  ) == -1
                ) {
                  return;
                }

                let canAdd = true;
                for (let index = 0; index < category.Lines.length; index++) {
                  const line = category.Lines[index];
                  const expenseProp = line.Properties.find(
                    (p) => p.Name === 'ExpenseCode',
                  );
                  console.log('Found expenseProp', expenseProp.Value);
                  console.log('Found changedProperty', changedProperty.Value);
                  if (expenseProp.Value === changedProperty.Value) {
                    console.log('Found', expenseProp.Value);
                    canAdd = false;
                    break;
                  }
                }
                if (canAdd) {
                  RecordModel.addLineToTable(
                    recordModel,
                    lineSection,
                    category,
                    moduleStructure.defaultValues,
                    category.Lines,
                    layoutService,
                    moduleStructure,
                    parentComponent.nzTableComponent,
                    changedProperty.Value,
                  );
                }
              } else {
                RecordModel.addLineToTable(
                  recordModel,
                  lineSection,
                  category,
                  moduleStructure.defaultValues,
                  category.Lines,
                  layoutService,
                  moduleStructure,
                  parentComponent.nzTableComponent,
                  changedProperty.Value,
                );
              }
            } else if (
              changedProperty.ActionType ===
              ChangedValueModelActionType.DeleteLine
            ) {
            }
            const section = moduleStructure.module.Sections.find(
              (x) => x.XmlTagName === changedProperty.CategoryId,
            );
            const recordLine = category.Lines.find(
              (x) => x.Id === changedProperty.LineId,
            );
            RecordModel.refineTheRecordModelLine(
              layoutService,
              section,
              recordLine,
              moduleStructure.defaultValues,
            );

            layoutService.lineAdded.emit({
              recordLine,
              moduleStructure: moduleStructure,
              section: section,
              recordModel: recordModel,
            });
          }
        } else if (
          actionResult.ResultType === ResultType.NavigateToRecordPage
        ) {
          const result = actionResult.Result as any;
          RecordPageComponent.openRecordPage(drawerService, {
            actionType: result.EventType,
            drawerTitle: layoutService.translate(`Execute Action`),
            inDrawer: true,
            moduleId: result.ModuleId,
            moduleActionType: result.ActionType,
            sourceModuleId: result.SourceObject,
            parentComponent: this,
            recordId:
              result.EventType === 'Edit'
                ? result.SelectedId.toString()
                : undefined,
            sourceRecordId:
              result.EventType !== 'Edit' && result.SelectedId != null
                ? result.SelectedId.toString()
                : undefined,
            recordModel: undefined,
            customActionCode: result.CustomActionCode,
            initValues: result.InitValues,
          });
        } else if (actionResult.ResultType === ResultType.SimpleResult) {
          const result = actionResult.Result as any;
          if (result.Success) {
            parentComponent.message.success(
              layoutService.translate(
                'Your operation has been completed successfully!',
              ) +
                ' ' +
                result.Msg,
            );

            if (result.Url != null) {
              window.open(g.apiBaseUrl + result.Url + '&' + g.getUrlSuffix());
            }

            if (result.Reload) {
              parentComponent.reloadModel();
            }
          } else {
            parentComponent.message.error(result.Msg);
          }
        } else if (
          actionResult.ResultType === ResultType.NavigateToRecordList
        ) {
          const result = actionResult.Result as any;
          if (result.Success) {
            parentComponent.message.success(
              layoutService.translate(
                'Your operation has been completed successfully!',
              ) +
                ' ' +
                result.Msg,
            );
            parentComponent.recordPage.backButtonClicked.emit();
            layoutService.refreshListEmitter.emit();
          } else {
            parentComponent.message.error(result.Msg);
          }
        } else if (actionResult.ResultType === ResultType.ReportActionResult) {
        } else if (actionResult.ResultType === ResultType.NavigateToPage) {
          const result = actionResult.Result as any;
          if (result.Success) {
            parentComponent.message.success(
              layoutService.translate(
                'Your operation has been completed successfully!',
              ) +
                ' ' +
                result.Msg,
            );
            if (result.Url != null) {
              // window.open(result.Url + '&' + g.getUrlSuffix(), '_self');
              if (
                result.Params != null &&
                result.Params !== undefined &&
                result.Params !== ''
              ) {
                const params = JSON.parse(result.Params);
                router.navigate([`${result.Url}`], {
                  queryParams: params,
                });
              } else {
                router.navigate([`${result.Url}`]);
              }
            }
          } else {
            parentComponent.message.error(result.Msg);
          }
        } else if (actionResult.ResultType === ResultType.OpenURL) {
          const result = actionResult.Result as any;
          if (result.Success) {
            parentComponent.message.success(
              layoutService.translate(
                'Your operation has been completed successfully!',
              ) +
                ' ' +
                result.Msg,
            );

            if (result.Url != null) {
              window.open(result.Url, '_self');
            }
          } else {
            parentComponent.message.error(result.Msg);
          }
        } else if (actionResult.ResultType === ResultType.OpenRecordList) {
          const result = actionResult.Result as any;
          const linkedModule = result.LinkedModule;
          const singleSelection = result.SingleSelecion;
          //const singleSelection = false;
          const moduleFilterId = result.ModuleFilterId;

          const args: RecordListDrawerArgs = {
            parentComponent,
            moduleId: Number(linkedModule),
            inDrawer: true,
            isSingleSelection: singleSelection,
            moduleFilterId: moduleFilterId,
            customActionCode: customActionCode,
            term: '',
          };

          RecordsListComponent.openRecordListDrawer(drawerService, args);
        }
      });
  }
  static addLineToTable(
    recordModel: RecordModel,
    section: Section,
    recordCat: RecordCategory,
    defaultVals,
    lines: RecordLine[],
    // tslint:disable-next-line: align
    layoutService: LayoutService,
    moduleStructure: ModuleStructure,
    nzTableComponent: NzTableComponent,
    values = null,
  ) {
    let recordCategory: RecordCategory = null;
    recordModel.Categories.forEach((category) => {
      if (category.Id === section.XmlTagName) {
        recordCategory = category;
        return;
      }
    });
    if (recordCategory.Lines.length > 0) {
      let MaxIndex = 0;
      let copyOfrecordCategory = LayoutService.HardCopyObject(recordCategory);
      let sortedLines = copyOfrecordCategory.Lines.sort((a, b) => {
        const lineNumA = a.Properties.find(
          (item) =>
            (recordModel.ObjectKey === 'BlanketAgreement' &&
              item.Name === 'AgreementRowNumber') ||
            item.Name === 'LineNum' ||
            item.Name === 'LineNumber' ||
            item.Name === 'Line' ||
            item.Name === 'LineId',
        ).ValueAsObject;
        const lineNumB = b.Properties.find(
          (item) =>
            (recordModel.ObjectKey === 'BlanketAgreement' &&
              item.Name === 'AgreementRowNumber') ||
            item.Name === 'LineNum' ||
            item.Name === 'LineNumber' ||
            item.Name === 'Line' ||
            item.Name === 'LineId',
        ).ValueAsObject;
        return lineNumA - lineNumB;
      });

      const lastLine = sortedLines[sortedLines.length - 1].Properties.find(
        (x) =>
          (recordModel.ObjectKey === 'BlanketAgreement' &&
            x.Name === 'AgreementRowNumber') ||
          x.Name === 'LineNum' ||
          x.Name === 'LineNumber' ||
          x.Name === 'Line' ||
          x.Name === 'LineId',
      );
      if (lastLine != null) {
        MaxIndex = lastLine.ValueAsObject;
      }
      // this logic added in order to handle MagB1 objects which dont have LineNum
      else {
        MaxIndex = recordCategory.Lines.indexOf(
          recordCategory.Lines[recordCategory.Lines.length - 1],
        );
      }

      recordCategory.MaxIndex = MaxIndex;
    } else if (
      recordCategory.Lines.length === 0 &&
      recordCategory.DeletedLines !== undefined &&
      recordCategory.DeletedLines.length > 0
    ) {
      let MaxIndex = recordCategory.MaxIndex++;
      recordCategory.MaxIndex = MaxIndex;
    } else {
      recordCategory.MaxIndex = undefined;
    }
    if (recordCategory == null) {
      recordCategory = {
        Id: section.XmlTagName,
        Lines: [],
        DeletedLines: [],
      };
      recordModel.Categories.push(recordCategory);
    }
    if (recordCategory.Lines.length !== 0 && recordCategory.MaxIndex === 0) {
      if (
        recordModel.ObjectKey === 'InventoryCounting' ||
        recordModel.ObjectKey === 'InventoryPosting' ||
        recordModel.ObjectKey === 'oProductionOrders'
      ) {
        if (
          recordCat.MaxIndex === 0 ||
          recordCat.MaxIndex === undefined ||
          isNaN(recordCat.MaxIndex)
        ) {
          recordCategory.MaxIndex =
            Math.max.apply(
              Math,
              recordCategory.Lines.map((o) => {
                if (
                  o.Properties.find((prop) => prop.Name === 'LineNumber') ===
                  undefined
                ) {
                  // next line modified because the max line num is working in not proper way (james)
                  // Old line (return recordCategory.Lines.length)
                  return recordCategory.Lines.indexOf(
                    recordCategory.Lines[recordCategory.Lines.length - 1],
                  );
                } else {
                  return o.Properties.find((prop) => prop.Name === 'LineNumber')
                    .ValueAsObject;
                }
              }),
            ) + 1;
        }
      } else if (recordModel.ObjectKey === 'BlanketAgreement') {
        if (
          recordCat.MaxIndex === 0 ||
          recordCat.MaxIndex === undefined ||
          isNaN(recordCat.MaxIndex)
        ) {
          recordCategory.MaxIndex =
            Math.max.apply(
              Math,
              recordCategory.Lines.map((o) => {
                if (
                  o.Properties.find(
                    (prop) => prop.Name === 'AgreementRowNumber',
                  ) === undefined
                ) {
                  // next line modified because the max line num is working in not proper way (james)
                  // Old line (return recordCategory.Lines.length)
                  return recordCategory.Lines.indexOf(
                    recordCategory.Lines[recordCategory.Lines.length - 1],
                  );
                } else {
                  return o.Properties.find(
                    (prop) => prop.Name === 'AgreementRowNumber',
                  ).ValueAsObject;
                }
              }),
            ) + 1;
        }
      } else {
        if (
          recordCat.MaxIndex === 0 ||
          recordCat.MaxIndex === undefined ||
          isNaN(recordCat.MaxIndex)
        ) {
          recordCategory.MaxIndex =
            Math.max.apply(
              Math,
              recordCategory.Lines.map((o) => {
                if (
                  o.Properties.find((prop) => prop.Name === 'LineNum') ===
                  undefined
                ) {
                  // next line modified because the max line num is working in not proper way (james)
                  // Old line (return recordCategory.Lines.length)
                  return recordCategory.Lines.indexOf(
                    recordCategory.Lines[recordCategory.Lines.length - 1],
                  );
                } else {
                  return o.Properties.find((prop) => prop.Name === 'LineNum')
                    .ValueAsObject;
                }
              }),
            ) + 1;
        }
      }
    } else {
      if (
        recordCategory.MaxIndex === undefined ||
        recordCategory.MaxIndex == null
      ) {
        recordCategory.MaxIndex = 0;
      } else {
        recordCategory.MaxIndex++;
      }
    }

    if (
      recordCategory.LineToDelete != null &&
      recordCategory.LineToDelete !== undefined &&
      recordCategory.LineToDelete !== '' &&
      recordModel.EventType == EventType.Update
    ) {
      console.log(recordCategory.LineToDelete);
      const numbers = recordCategory.LineToDelete.toString()
        .split(',')
        .map(Number);
      const maxNumber = Math.max(...numbers);
      if (recordCategory.MaxIndex < maxNumber) {
        recordCategory.MaxIndex = maxNumber + 1;
      }
    }

    let recordLine: RecordLine = null;
    recordLine = {
      Id: recordCategory.MaxIndex,
      MaxIndex: recordCategory.MaxIndex,
      Properties: [],
    };

    // this.maxLineNum = this.maxLineNum + 1;
    RecordModel.refineTheRecordModelLine(
      layoutService,
      section,
      recordLine,
      defaultVals,
    );

    layoutService.lineAdded.emit({
      recordLine,
      moduleStructure: moduleStructure,
      section: section,
      recordModel: recordModel,
    });

    if (values != null) {
      Object.keys(values).forEach((key) => {
        const property = recordLine.Properties.find((x) => x.Name === key);
        if (property != null) {
          property.Value = values[key].toString();
          property.ValueAsObject = values[key];
        }
      });
    }
    recordCategory.Lines = [...recordCategory.Lines, recordLine];
    lines = recordCategory.Lines;
    // recordCategory.MaxIndex = this.maxLineNum;

    recordLine.IsNew = true;

    for (const property of recordLine.Properties) {
      const field = section.Fields.find(
        (p) => p.PropertyName === property.Name,
      );
      if (field.ParentProperties != null && field.ParentProperties !== '') {
        let queryIdToExecute = field.SQLStatementParentChanged;
        if (queryIdToExecute == null || queryIdToExecute === 0) {
          queryIdToExecute = field.SQLStatementId;
        }

        if (queryIdToExecute != null && queryIdToExecute !== 0) {
          layoutService.getFieldValueOnParentChange(
            recordModel,
            recordCategory,
            recordLine,
            property,
            queryIdToExecute,
            field,
            moduleStructure,
            true,
          );
        }
      }
    }

    //nzTableComponent?.cdkVirtualScrollViewport?.scrollToIndex(recordLine.Id);

    setTimeout(() => {
      const parentElement = (nzTableComponent as any).elementRef.nativeElement;
      const tableBodyElement = parentElement.querySelector('.ant-table-body');

      if (tableBodyElement) {
        // Scroll the element to the bottom
        tableBodyElement.scrollTop =
          tableBodyElement.scrollHeight - tableBodyElement.clientHeight;
      }
    }, 1500);
  }
  static deleteLine(
    id: number,
    recordModel: RecordModel,
    section: Section,
    layoutService: LayoutService,
    moduleStructure: ModuleStructure,
    // tslint:disable-next-line: align
    pushDeletedLine: (RecordLine) => void,
    callEditSubTotalLine: (lineToDeleteIndex) => void,
    prepareSectionLines: (lines) => void,
    bulkDelete: boolean = false,
  ) {
    let recordCategory: RecordCategory = null;
    const deletedLines = [];
    recordModel.Categories.forEach((category) => {
      if (category.Id === section.XmlTagName) {
        recordCategory = category;
      }
    });
    if (
      recordCategory.SpecialLines !== null &&
      recordCategory.SpecialLines !== undefined
    ) {
      recordCategory.SpecialLines.forEach((spline) => {
        if (spline.AftLineNum >= id) {
          spline.AftLineNum--;
        }
      });
    }
    if (recordCategory !== null) {
      if (recordCategory.MaxIndex === 0 && section.KeyPropertyName != null) {
        console.log('recordCategory.MaxIndex>', recordCategory.MaxIndex);
        recordCategory.MaxIndex =
          Math.max.apply(
            Math,
            recordCategory.Lines.map(
              (o) =>
                o.Properties.find(
                  (prop) => prop.Name === section.KeyPropertyName,
                ).ValueAsObject,
            ),
          ) + 1;
      }
      // else if (recordCategory.MaxIndex === 0 && this.section.KeyPropertyName == null) {
      //   recordCategory.MaxIndex =
      //     Math.max.apply(
      //       Math,
      //       recordCategory.Lines.map(
      //         (o) =>
      //           o.Properties.find(
      //             (prop) => prop.Name === this.section.KeyPropertyName
      //           ).ValueAsObject
      //       )
      //     ) + 1;
      // }

      const lineToDelete = recordCategory.Lines.find((d) => d.Id === id);
      const lineToDeleteIndex = recordCategory.Lines.findIndex(
        (d) => d.Id === id,
      );

      console.log('lineToDelete>', lineToDelete);
      if (lineToDelete == null || lineToDelete === undefined) {
        return;
      }

      const keyPropName = lineToDelete.Properties.find(
        (prop) => prop.Name === section.KeyPropertyName,
      );

      if (keyPropName != null) {
        // this.editSubTotalLine(this.lines[lineToDeleteIndex - 1].Id);
        callEditSubTotalLine(lineToDeleteIndex);
      }

      recordCategory.Lines = recordCategory.Lines.filter(
        (d) => d !== lineToDelete,
      ); // .splice(lineToDeleteIndex, 1);

      const lineNumberValue =
        keyPropName != null ? keyPropName.ValueAsObject : lineToDelete.Id;

      if (
        recordCategory.LineToDelete == null ||
        recordCategory.LineToDelete === undefined ||
        recordCategory.LineToDelete === ''
      ) {
        recordCategory.LineToDelete = lineNumberValue;
      } else {
        recordCategory.LineToDelete =
          recordCategory.LineToDelete + ',' + lineNumberValue;
      }

      recordCategory.KeyPropertyName = section.KeyPropertyName;
      recordCategory.PropertyNameInParent = section.PropertyNameInParent;

      deletedLines.push(lineToDelete);
      pushDeletedLine(lineToDelete);
      // recordCategory.Lines = recordCategory.Lines.filter((d) => d.Id !== id);
      if (!bulkDelete) {
        for (let i = 0; i < recordCategory.Lines.length; i++) {
          recordCategory.Lines[i].Id = i;
          const prop = recordCategory.Lines[i].Properties.find(
            (x) => x.Name === 'LineNum',
          );

          // Discord, caused problem in customer portal while deleting lines
          //if (prop != null) prop.ValueAsObject = i;
        }
      }

      layoutService.triggerDeleteRow(
        recordCategory,
        lineToDelete,
        lineToDeleteIndex,
        recordModel,
        moduleStructure,
      );
    }
    recordCategory.DeletedLines = deletedLines;
    // this.lines = recordCategory.Lines;
    prepareSectionLines(recordCategory.Lines);
  }
  static refineTheRecordModelLine(
    layoutService: LayoutService,
    section: any,
    recordLine: RecordLine,
    defaultVals: any,
  ) {
    for (const field of section.Fields) {
      let recordProperty = recordLine.Properties.find(
        (property) => property.Name === field.PropertyName,
      );

      if (recordProperty === undefined) {
        if (
          (section.XmlTagName ===
            'BlanketAgreements_ItemsLines|BlanketAgreements_ItemsLine' &&
            field.PropertyName === 'AgreementRowNumber') ||
          field.PropertyName === 'LineNum' ||
          field.PropertyName === 'LineNumber' ||
          field.Name === 'Line' ||
          field.Name === 'LineId'
        ) {
          recordProperty = {
            FieldId: field.Id,
            DataType: field.DataType,
            Name: field.PropertyName,
            FieldName: field.FieldName,
            ValueAsObject: recordLine.MaxIndex,
            DBValue: `${recordLine.MaxIndex}`,
            Disabled: field.Disabled,
            Visible: field.Visible,
            IsImage: field.AdditionalInformationParsed.IsImage,
          };
        } else {
          recordProperty = {
            FieldId: field.Id,
            DataType: field.DataType,
            Name: field.PropertyName,
            FieldName: field.FieldName,
            ValueAsObject: '',
            DBValue: '',
            Disabled: field.Disabled,
            ExecuteParentChangeOnLoad:
              field.AdditionalInformationParsed.ExecuteParentChangeOnLoad,
            Visible: field.Visible,
            IsImage: field.AdditionalInformationParsed.IsImage,
            EmptyValue: field.EmptyValue,
          };
        }

        if (field.AdditionalInformationParsed.UniqueDefaultValue) {
          layoutService
            .getDefaultValue(field.DefaultValueSQLStatementId)
            .subscribe((res: any) => {
              recordProperty.ValueAsObject = res.DefaultValue;
            });
        } else {
          const defaultValue =
            defaultVals[section.XmlTagName + '.' + field.PropertyName];
          if (defaultValue != null && defaultValue !== '{{index}}') {
            if (recordProperty.DataType === FieldDataType.Date) {
              recordProperty.ValueAsObject = moment(
                defaultValue,
                'YYYYMMDD',
              ).toDate();
            } else {
              recordProperty.ValueAsObject = defaultValue;
            }
          } else if (defaultValue === '{{index}}') {
            recordProperty.ValueAsObject = recordLine.MaxIndex;
          }
        }

        recordLine.Properties.push(recordProperty);
      } else {
        recordProperty.FieldId = field.Id;
        recordProperty.DataType = field.DataType;
        recordProperty.EmptyValue = field.EmptyValue;
      }
    }
    return recordLine;
  }

  static getOptions(
    field: Field,
    recordModel: RecordModel,
    rProperty: RecordProperties,
    sectionTagName: string,
    lineId: number,
    rCategory: RecordCategory,
    layoutService: LayoutService,
    moduleStructure: ModuleStructure,
  ) {
    const paramsNames = g.queriesData[field.SQLStatementId];
    const vals: string[] = [];

    if (paramsNames !== undefined) {
      for (const paramNames of paramsNames) {
        const sectionXmlTagName = paramNames.split('.')[0];
        const fieldPropertyName = paramNames.split('.')[1];

        if (sectionXmlTagName === sectionTagName) {
          let value = '';
          const recordLine = rCategory.Lines.find((l) => l.Id === lineId);
          const recordProperty = recordLine.Properties.find(
            (property) => property.Name === fieldPropertyName,
          );
          if (recordProperty != null) {
            value = recordProperty.DBValue;
            if (value === undefined || value == null || value === '') {
              value = recordProperty.ValueAsObject;
            }
          }

          vals.push(value);
        } else {
          let value = '';
          const recordCategory = recordModel.Categories.find(
            (category) => category.Id === sectionXmlTagName,
          );
          if (recordCategory != null && recordCategory.Lines.length > 0) {
            const recordLine = recordCategory.Lines[0];
            const recordProperty = recordLine.Properties.find(
              (property) => property.Name === fieldPropertyName,
            );
            if (recordProperty != null) {
              value = recordProperty.DBValue;
              if (value === undefined || value == null || value === '') {
                value = recordProperty.ValueAsObject;
              }
            }
          }
          vals.push(value);
        }
      }
    }

    if (rProperty.LoadingOptionsIndex == null) {
      rProperty.LoadingOptionsIndex = 0;
    }

    rProperty.LoadingOptionsIndex = rProperty.LoadingOptionsIndex + 1;
    const loadingOptionsIndex = rProperty.LoadingOptionsIndex;

    layoutService.getSelectValuesForProperty(
      moduleStructure,
      field.AdditionalInformationParsed.DataSourcePath,
      field.Id,
      field.SQLStatementId,
      paramsNames,
      vals,
      rProperty,
    );
  }
}

export class PriceQueueRequest {
  Id: string;
  DeliveryDate: string;
  PostingDate: string;
  Quantity: number;
  ItemCode: string;
  CardCode: string;
  DocCurr: string;
  DefaultUOMSqlStatementId: number;
  UomEntry: number;
}

export interface ActionUrl {
  UrlTemplate: string;
  Url: string;
  Icon: string;
  Class: string;
  Text: string;
  Multiple: boolean;
  Target: string;
  ShowConfirmation: boolean;
  ConfirmationMessage: string;
}

export interface Action {
  ModuleName: string;
  Icon: string;
  Name: string;
  ObjectId: string;
  Popup?: any;
  SortOrder: number;
  Url: string;
  Target?: string;
  GroupName?: string;
  AdditionalInformation?: any;
  AdditionalInformationParsed?: any;
  ActionUrls: ActionUrl[];
  FieldDescription: string;
  Id: number;
  //RecordDescription: string;
  //Areas: any[];
}

export class DiscountContractObj {
  FromDate: string;
  ToDate: string;
  DiscountPercent: number;
}

export interface Relation {
  from: number;
  to: number;
  arrows: string;
}

export interface RelationDocument {
  DocEntry: number;
  DocNum: number;
  DocTotal: string;
  DocTotalFC: string;
  PaidToDate: number;
  DocDate: string;
  NumAtCard: string;
  DocStatus: string;
  OpenAmount: number;
  ObjectDescription: string;
  IsIns: string;
  ObjType: number;
  //BaseDocuments: any[];
  //TargetDocuments: RelationDocument[];
  //RelatedPayment: RelationDocument[];
  AllDocuments?: any;
  Key: number;
  //Relations?: Relation[];
  DocCurrency: string;
  CANCELED: string;
  DocTotalValue: number;
  DocTotalValueFC: number;
  VatSum: number;
  IsMainDocument: boolean;
}

export interface AllDocument {
  Id: number;
  Value: RelationDocument;
}

export interface RelationMap {
  Relations: Relation[];
  AllDocuments: AllDocument[];
}
export interface Attachment {
  FullFilePath: string;
}
